import React, { useState, useEffect } from "react";
import api from "../../api/axios";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { Save, ArrowLeft } from "lucide-react";

function CreateSupplier() {
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [nit, setNit] = useState("");
  const [address, setAddress] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [errors, setErrors] = useState({});
  const [supplierCategoryId, setSupplierCategoryId] = useState("");
  const [categories, setCategories] = useState([]);
  const [isSavingAndContinuing, setIsSavingAndContinuing] = useState(false);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        // Esta ruta ahora apunta al nuevo controlador independiente
        const res = await api.get("/supplier-categories");
        setCategories(res.data);
      } catch (err) {
        console.error("Error cargando categorías", err);
      }
    };
    fetchCategories();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    let newErrors = {};

    // Validaciones frontend
    if (!name.trim()) newErrors.name = "El nombre es obligatorio";
    if (!supplierCategoryId) newErrors.supplier_category_id = "Debes seleccionar una categoría";
    if (email && !/^\S+@\S+\.\S+$/.test(email)) newErrors.email = "Correo inválido";

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    try {
      await api.post("/suppliers", {
        name,
        nit: nit.trim() === "" ? null : nit,
        address,
        phone,
        email: email.trim() === "" ? null : email,
        supplier_category_id: supplierCategoryId,
      });
      toast.success("Proveedor creado exitosamente");
      setErrors({});

      if (isSavingAndContinuing) {
        setName("");
        setNit("");
        setAddress("");
        setPhone("");
        setEmail("");
        setIsSavingAndContinuing(false);
      } else {
        navigate("/suppliers");
      }
    } catch (error) {
      if (error.response?.data?.errors) {
        let backendErrors = {};
        error.response.data.errors.forEach((err) => {
          backendErrors[err.path] = err.msg;
        });
        setErrors(backendErrors);
      } else {
        setErrors({ general: "Ocurrió un error inesperado" });
      }
    }
  };

  return (
    <div className="bg-white p-6 rounded-xl shadow-md max-w-xl mx-auto">
      <button
        onClick={() => navigate("/suppliers")}
        className="flex items-center gap-2 text-gray-600 hover:text-gray-900 mb-6"
      >
        <ArrowLeft size={20} />
        Volver a proveedores
      </button>

      <h2 className="text-3xl font-semibold text-gray-800 mb-6">
        Crear Proveedor
      </h2>

      {errors.general && (
        <div className="text-red-600 mb-4 text-sm">{errors.general}</div>
      )}

      <form onSubmit={handleSubmit} className="space-y-5">
        {/* Nombre */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Nombre
          </label>
          <input
            type="text"
            placeholder="Nombre del proveedor"
            value={name}
            onChange={(e) => setName(e.target.value)}
            className={`w-full border px-4 py-2 rounded-lg focus:outline-none focus:ring-2 ${errors.name ? "border-red-500 focus:ring-red-500" : "border-gray-300 focus:ring-blue-500"
              }`}
          />
          {errors.name && <p className="text-red-500 text-sm mt-1">{errors.name}</p>}
        </div>

        {/*SELECT DE CATEGORÍA */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Categoría de Proveedor
          </label>
          <select
            value={supplierCategoryId}
            onChange={(e) => setSupplierCategoryId(e.target.value)}
            className={`w-full border px-4 py-2 rounded-lg focus:outline-none focus:ring-2 ${errors.supplier_category_id ? "border-red-500 focus:ring-red-500" : "border-gray-300 focus:ring-blue-500"
              }`}
          >
            <option value="">Seleccione una categoría...</option>
            {categories.map((cat) => (
              <option key={cat.id} value={cat.id}>
                {cat.name}
              </option>
            ))}
          </select>
          {errors.supplier_category_id && (
            <p className="text-red-500 text-sm mt-1">{errors.supplier_category_id}</p>
          )}
        </div>

        {/* NIT */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            NIT
          </label>
          <input
            type="text"
            placeholder="NIT del proveedor"
            value={nit}
            onChange={(e) => setNit(e.target.value)}
            className={`w-full border px-4 py-2 rounded-lg focus:outline-none focus:ring-2 ${errors.nit ? "border-red-500 focus:ring-red-500" : "border-gray-300 focus:ring-blue-500"
              }`}
          />
          {errors.nit && <p className="text-red-500 text-sm mt-1">{errors.nit}</p>}
        </div>

        {/* Dirección */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Dirección
          </label>
          <input
            type="text"
            placeholder="Dirección del proveedor"
            value={address}
            onChange={(e) => setAddress(e.target.value)}
            className={`w-full border px-4 py-2 rounded-lg focus:outline-none focus:ring-2 ${errors.address ? "border-red-500 focus:ring-red-500" : "border-gray-300 focus:ring-blue-500"
              }`}
          />
          {errors.address && <p className="text-red-500 text-sm mt-1">{errors.address}</p>}
        </div>

        <div className="grid grid-cols-2 gap-4">
          {/* Teléfono */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Teléfono
            </label>
            <input
              type="text"
              placeholder="Teléfono"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              className={`w-full border px-4 py-2 rounded-lg focus:outline-none focus:ring-2 ${errors.phone ? "border-red-500 focus:ring-red-500" : "border-gray-300 focus:ring-blue-500"
                }`}
            />
            {errors.phone && <p className="text-red-500 text-sm mt-1">{errors.phone}</p>}
          </div>

          {/* Email */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Correo electrónico
            </label>
            <input
              type="email"
              placeholder="correo@ejemplo.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className={`w-full border px-4 py-2 rounded-lg focus:outline-none focus:ring-2 ${errors.email ? "border-red-500 focus:ring-red-500" : "border-gray-300 focus:ring-blue-500"
                }`}
            />
            {errors.email && <p className="text-red-500 text-sm mt-1">{errors.email}</p>}
          </div>
        </div>

        <div className="flex gap-4">
          <button
            type="submit"
            onClick={() => setIsSavingAndContinuing(false)}
            className="flex items-center gap-2 bg-green-600 hover:bg-green-700 text-white px-5 py-2 rounded-lg shadow transition duration-300"
          >
            <Save size={18} />
            Crear
          </button>

          <button
            type="submit"
            onClick={() => setIsSavingAndContinuing(true)}
            className="flex items-center gap-2 bg-blue-600 hover:bg-blue-700 text-white px-5 py-2 rounded-lg shadow transition duration-300"
          >
            <Save size={18} />
            Crear y seguir
          </button>
        </div>
      </form>
    </div>
  );
}

export default CreateSupplier;
